import React from 'react';
import '../interfaceSettings.css';
import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AdminHome = () => {
    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4">Administrator Dashboard</h1>
            <Row>
                <Col xs={12} md={6} lg={4} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex flex-column">
                            <Card.Title><strong>👤 Role Manager</strong></Card.Title>
                            <Card.Text>
                                View registered user profiles and assign site roles.
                            </Card.Text>
                            <div className="mt-auto">
                                <Link to="/adminControlPanel/users" className="btn btn-primary">Manage Users</Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6} lg={4} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex flex-column">
                            <Card.Title><strong>🎞️ Video Manager</strong></Card.Title>
                            <Card.Text>
                                Manage videos and how they are listed.
                            </Card.Text>
                            <div className="mt-auto">
                                <Link to="/adminControlPanel/videos" className="btn btn-primary w-100">Manage Videos</Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6} lg={4} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex flex-column">
                            <Card.Title><strong>🗺️ Trail Manager</strong></Card.Title>
                            <Card.Text>
                                View and manage trails.
                            </Card.Text>
                            <div className="mt-auto">
                                <a href="/adminControlPanel/trails" className="btn btn-primary w-100">
                                    Manage Trails
                                </a>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6} lg={4} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex flex-column">
                            <Card.Title><strong>📝 Feedback Manager</strong></Card.Title>
                            <Card.Text>
                                View and manage user feedback.
                            </Card.Text>
                            <div className="mt-auto">
                                <Link to="/adminControlPanel/feedback" className="btn btn-primary w-100">Manage Feedback</Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6} lg={4} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex flex-column">
                            <Card.Title><strong>📌 Bench Manager</strong></Card.Title>
                            <Card.Text>
                                Manage bench pins and their assignment.
                            </Card.Text>
                            <div className="mt-auto">
                                <a href="/adminControlPanel/bench" className="btn btn-primary w-100">
                                    Manage Benches
                                </a>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={6} lg={4} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex flex-column">
                            <Card.Title><strong>📊 Analytics Panel</strong></Card.Title>
                            <Card.Text>
                                View video and user analytics.
                            </Card.Text>
                            <div className="mt-auto">
                                <a href="/adminAnalytics" className="btn btn-primary w-100">
                                    View Analytics
                                </a>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};
export default AdminHome;
